import { Editor } from '@tiptap/react';

export const OPEN_MEMO_MEDIA_INSERT_MODAL_EVENT = 'countercyclical:memo:open-media-insert-modal';

export type MemoMediaType = 'image' | 'video';

export interface OpenMemoMediaInsertModalEventDetail {
    editor: Editor;
    mediaType: MemoMediaType;
}
